import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import 'bootstrap/dist/css/bootstrap.min.css';

function AuthorAcceptedPapers() {
    const [submissions, setSubmissions] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [error, setError] = useState('');
    const token = localStorage.getItem('authToken');
    const PlatformID = localStorage.getItem('platformID');
    let authorID = localStorage.getItem('AuthorID');
    const API = process.env.REACT_APP_API_BASE_URL;

    if (token) {
        const decoded = jwtDecode(token);
        authorID = decoded.id;
    }

    useEffect(() => {
        const fetchPaper = async () => {
            try {
                const res = await axios.get(
                    `${API}/api/author/papers/${PlatformID}/${authorID}`
                );

                const acceptedPapers = res.data.totalPaper.filter(paper =>
                    paper.Status === 'Accept' && paper.SubmissionAccepted === 1
                );

                setSubmissions(acceptedPapers);
            } catch (error) {
                console.error('Error while fetching papers:', error);
                setError('Unable to fetch accepted papers');
            }
        };
        if (authorID) fetchPaper();
    }, [authorID]);

    // Filter accepted submissions by search term on SubmissionTitle
    const filtered = submissions.filter(s =>
        s.SubmissionTitle.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <div className="container mt-5 ml-2">
                <h3 className="page-title mb-4">Accepted Papers</h3>

                {/* Search Box */}
                <div className="mb-3">
                    <input
                        type="text"
                        placeholder="Search by Submission Title"
                        className="form-control"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                {filtered.length > 0 ? (
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover align-middle text-center">
                            <thead className="table-primary">
                                <tr>
                                    <th scope="col">Submission Title</th>
                                    <th scope="col">Submission Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map((s, index) => (
                                    <tr key={index}>
                                        <td>{s.SubmissionTitle}</td>
                                        <td>{new Date(s.submissiondate).toLocaleDateString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="alert alert-info text-center">
                        {submissions.length === 0
                            ? 'No papers available.'
                            : 'No submissions match your search.'}
                    </div>
                )}

                {error && (
                    <div className="alert alert-danger text-center">{error}</div>
                )}
            </div>
        </>
    );
}

export default AuthorAcceptedPapers;
